export const formatDateTime = (value: string | null | undefined, start = 0, end = 16) => {
  if (!value) return "-";
  return value.replace("T", " ").slice(start, end);
};

export const formatNullable = (value: string | number | boolean | null | undefined) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};
